module.exports = __webpack_public_path__ + "img/AFMS_KEY_ON.2992c0f7.png";